import { render, staticRenderFns } from "./EquivalencesCreate.vue?vue&type=template&id=41d87d87"
import script from "./EquivalencesCreate.vue?vue&type=script&lang=js"
export * from "./EquivalencesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports